<template>
  <el-dialog
    custom-class="community-taxi-dialog"
    :visible.sync="isShowDialog"
    :close-on-click-modal="false"
    width="900px"
    center
    @closed="close"
  >
    <template #title>
      <div class="title-wrapper">
        <div class="title">
          計程車代叫
        </div>
      </div>
    </template>
    <iframe
      v-if="link"
      title="計程車代叫"
      width="100%"
      height="100%"
      :src="link"
      frameborder="0"
      allow="geolocation"
    >
    </iframe>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      isShowDialog: false,
      link: ''
    }
  },
  methods: {
    /**
     * 開啟計程車代叫 dialog，內部組裝含 token 的連結
     */
    open () {
      const baseUrl = process.env.VUE_APP_COMMUNITY_TAXI_URL
      if (!baseUrl) {
        this.$message.warning('請先設定計程車代叫連結')
        return
      }
      // Sentry MGMT-MX: 避免在初始化 data 時呼叫 $getCookie 導致零星取不到資料的錯誤
      const comLoginToken = this.$getCookie('comLoginToken').replace('token=', '')
      if (!comLoginToken) {
        this.$message.warning('登入憑證已過期，請重新登入')
        return
      }
      const url = new URL(baseUrl)
      url.searchParams.set('comLoginToken', comLoginToken)
      this.link = url.toString()
      this.isShowDialog = true
    },
    close () {
      this.link = ''
    }
  }
}
</script>

<style lang="scss" scoped>
$dialogHeaderHeight: 64px;

::v-deep .community-taxi-dialog {
  @include basicDialog();
  margin-top: 5vh !important;
  margin-bottom: 5vh !important;
  height: 90vh;

  .el-dialog__header {
    position: relative;
    height: $dialogHeaderHeight;
    padding: 0 24px 0 32px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: $white !important;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);

    .title-wrapper {
      display: flex;
      align-items: center;
    }

    .title {
      font-size: map-get($fontSize, large);
      font-weight: 600;
      color: $fontColor;
    }
  }

  .el-dialog__headerbtn {
    position: relative;
    top: unset;
    right: unset;
  }

  .el-dialog__close {
    font-size: map-get($fontSize, xxx-large);
  }

  .el-dialog__body {
    height: calc(100% - #{$dialogHeaderHeight});
    width: 100%;
    max-height: unset;
    padding: 0;
    overflow: hidden;
  }
}
</style>
